<!-- ? Header -->
<div class="header" (click)="onBackClicked()">
  <img
    src="wealth-assets/icons/arrow-right.svg"
    alt=""
    [style]="{
      width,
      height,
    }"
  />
  <p class="title">
    {{ title | translate }}
  </p>
</div>
